import './ConnectionError.css';

export default function ConnectionError({ onRetry, status, title = 'Нет связи', hint }) {
  const code = Number(status);
  const message = [502, 503, 504].includes(code)
    ? `Сервер временно недоступен (ошибка ${code}).`
    : 'Не удалось получить ответ от сервера. Проверьте соединение.';

  return (
    <div className="connectionError" role="alert">
      <h2>{title}</h2>
      <p>{message}</p>
      {hint && <p>{hint}</p>}
      <button type="button" onClick={onRetry}>Повторить</button>
    </div>
  );
}
